import RedirectToSlack from '@components/App/RedirectToSlack/RedirectToSlack'
import Theme from '@components/ArtBoard/Theme/Theme'
import type React from 'react'

// Redirects to the Slack community invite (route /join-slack).
export const JoinSlack: React.FC = () => (
  <Theme>
    <RedirectToSlack />
  </Theme>
)
